<template>
  <div class="template-container">
    <div class="content-container" :class="{ 'sidebar-displayed': showSidebar }">
      <div class="content-header">
        <div class="header-left">
          <SearchButton v-model="usersSearchText" />
        </div>
        <div class="header-right add-button" @click="openCreateUsersModal">
          <span class="material-symbols-outlined align-middle"> add </span> Add User
        </div>
        <!-- <i
                class="material-icons-outlined align-middle button"
                :class="{ active: showUsersFilters }"
                title="Filter Users"
                @click="usersFilterIconClick"
              >
                filter_alt
              </i> -->

        <!-- <div v-if="showUsersFilters" class="filters">
              TODO: Example (No filters yet) -->
        <!-- <label for="groupsStatus" class="status">
                <span>Playlists</span>
                <select
                  ref="groupsStatus"
                  name="groupsStatus"
                  id="groupsStatus"
                  @change="manageFilters('groupsStatus')"
                  v-model="filters.groupsStatus"
                >
                  <option value="all">All</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="unknown">Unknown</option>
                </select>
              </label>
            </div> -->
      </div>
      <div class="table-container">
        <!-- <div>organisationIdParam: {{ organisationIdParam }}</div> -->
        <UsersList
          v-if="organisationIdParam === organisation?.organisation_id"
          @userSelected="selectUser"
          @toggleSidebar="toggleSidebar"
          :search-text="usersSearchText"
          :organisation="organisation"
          ref="userList"
        />
      </div>
    </div>

    <UsersSidebar
      v-if="showSidebar"
      :user="selectedUser"
      @userUpdated="getUsers"
      @userDeleted="getUsers"
      :organisation="organisation"
    />

    <UserModal
      @closeModal="showCreateUserModal = false"
      @getUsers="getUsers"
      v-if="showCreateUserModal"
      title="Create User"
    />
  </div>
</template>

<script>
  import { GET_ORGANISATION_ROLES } from '@/store/actions/roles';
  import {
    ADMIN_ORGANISATIONS_GET,
    ORGANISATION_REQUEST,
    SET_ORGANISATIONS,
  } from '@/store/actions/organisation';

  import UsersList from '@/components/admin/OrganisationDetails/Users/UsersList.vue';
  import UserModal from '@/components/admin/OrganisationDetails/Users/UserModal.vue';
  import UsersSidebar from '@/components/admin/OrganisationDetails/Users/UsersSidebar.vue';
  import SearchButton from '@/components/common/SearchButton.vue';
  import { GENERIC_FETCH_ERROR_MESSAGE } from '@/constant/const';

  export default {
    name: 'Users',

    components: { UsersList, UserModal, UsersSidebar, SearchButton },

    data() {
      return {
        showCreateUserModal: false,
        showUsersFilters: false,
        showUsersSearchBox: false,
        usersSearchText: '',
        selectedUser: null,
        showSidebar: false,
      };
    },

    computed: {
      isAdmin() {
        return this.$store.getters.isAdministrator;
      },

      organisation() {
        return this.$store.state.organisation.organisation;
      },

      organisationIdParam() {
        return this.$route.params.organisation_id;
      },

      isOrganisationLoaded() {
        const organisationsLoaded = this.$store.state.organisation.organisations.length !== 0;
        return (
          organisationsLoaded &&
          this.organisationIdParam &&
          this.organisation &&
          this.organisation.organisation_id === this.organisationIdParam
        );
      },
    },

    async mounted() {
      if (!this.isOrganisationLoaded) {
        await this.getOrganizations();
      }
      await this.getOrganisationRoles();
      await this.getUsers();
    },

    methods: {
      async getUsers() {
        await this.$refs.userList.getUsers();
      },

      async getOrganizations(refreshData = false) {
        if (this.isAdmin) {
          await this.$store.dispatch(ADMIN_ORGANISATIONS_GET, this.organisationIdParam);
          return;
        }

        if (!this.organisation || refreshData) {
          await this.$store.dispatch(ORGANISATION_REQUEST);
          this.$store.commit(SET_ORGANISATIONS, [this.organisation]);
        }
      },

      openCreateUsersModal() {
        this.showCreateUserModal = true;
      },

      usersFilterIconClick() {
        this.showUsersFilters = !this.showUsersFilters;
      },

      usersSearchIconClick() {
        this.showUsersSearchBox = !this.showUsersSearchBox;
      },

      selectUser(user) {
        this.selectedUser = user;
      },

      toggleSidebar(show) {
        this.showSidebar = show;
      },

      async getOrganisationRoles() {
        const fetchedSuccessfully = await this.$store.dispatch(GET_ORGANISATION_ROLES);

        if (!fetchedSuccessfully) {
          this.$toasted.global.general_error({
            message: GENERIC_FETCH_ERROR_MESSAGE,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content-body {
    padding: 0;
    width: 100%;
  }
  .template-container {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .content-container {
    width: 100%;
    height: 100%;

    &.sidebar-displayed {
      width: 80%;
    }
  }

  .users-sidebar {
    overflow: hidden;
    position: relative;
    height: 100%;
    background-color: #fff;
    width: 20vw;
    max-width: 20vw;
    min-width: 20vw;
    font-size: 14px;
    padding: 20px;
    margin-left: 8px;
    z-index: 1;
  }

  .content-header {
    margin: 10px 10px;
    display: grid;
    grid-template-columns: auto 115px;

    height: 40px;
    padding: 0;
  }

  .table-container {
    overflow-y: auto;
    overflow-x: visible;
    max-height: 90%;
    width: 100%;
    padding-right: 12px;
  }

  .material-symbols-outlined {
    font-size: 24px;
  }

  .header-left {
    display: flex;
    align-items: center;
  }

  .header-right {
    display: grid;
    align-items: center;
    grid-template-columns: 24px auto;
    gap: 12px;
  }

  .add-button {
    color: $primaryRed;
    font-family: Poppins;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    cursor: pointer;
    font-weight: bold !important;
    display: flex;
    justify-content: space-evenly;
  }
</style>
